import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Chapter, Reveal } from "@/components/Reveal";
import { INDUSTRIES, OFFICE_IMG } from "@/data/content";

export default function About() {
  const imgRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: imgRef,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="about" className="py-24 md:py-32 border-t border-white/10" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          <div>
            <Reveal>
              <Chapter num="Chapter 02" label="Who We Are" />
              <h2 className="font-heading text-4xl sm:text-5xl tracking-tight leading-tight font-medium text-white">
                One partner for people, paperwork & growth.
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-8 text-base sm:text-lg leading-relaxed text-zinc-400">
                HR99 Global Services is a full-spectrum HR and business
                support agency. We recruit with AI-driven precision — from
                freshers to seasoned leadership — and we carry the operational
                weight behind your business: registrations, taxation,
                compliance and employee development.
              </p>
              <p className="mt-6 text-base sm:text-lg leading-relaxed text-zinc-400">
                Employers get talent in weeks, not months. Candidates get a
                team that actually calls back. That's the standard we've kept
                across 400+ cities and 5,000+ client engagements.
              </p>
            </Reveal>

            <Reveal delay={0.25} className="mt-12">
              <p className="text-xs uppercase tracking-[0.25em] text-zinc-500 mb-5">
                Industries we serve
              </p>
              <div className="flex flex-wrap gap-3" data-testid="industries-list">
                {INDUSTRIES.map((ind) => (
                  <span
                    key={ind}
                    className="px-4 py-2 border border-white/10 text-sm text-zinc-300 hover:border-primary hover:text-primary transition-colors duration-300 cursor-default"
                    data-testid={`industry-${ind.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  >
                    {ind}
                  </span>
                ))}
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.2}>
            <div ref={imgRef} className="relative overflow-hidden border border-white/10 aspect-[4/5]">
              <motion.img
                src={OFFICE_IMG}
                alt="HR99 Global consultants at work"
                className="w-full h-[116%] object-cover"
                style={{ y }}
                data-testid="about-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-zinc-950/80 via-transparent to-transparent" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
